<template>
    <div>
        <div class='panBody'>
            <el-card shadow="hover">
                <span class="label-span">
                    <label class="label">日期范围</label> 
<!--                    <el-date-picker v-model="query.startDay" value-format="yyyy-MM-dd" style="width:142px;" type="date"-->
<!--                                    placeholder="开始日期"></el-date-picker>-->
<!--                    <el-date-picker class="mr10" v-model="query.endDay" value-format="yyyy-MM-dd" style="width:143px;"-->
<!--                                    type="date" placeholder="截止日期"></el-date-picker>-->
<!--                    -->
                     <el-date-picker v-model="query.startDay" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;" type="datetime"  placeholder="开始时间"></el-date-picker>
                    <el-date-picker v-model="query.endDay" :picker-options="pickerOptions2" value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;margin-right:10px;" type="datetime"   placeholder="结束时间"></el-date-picker>

                </span>
                <span class="label-span">
                    <label class="label">上游资源</label> 
                    <el-select class="mr10" v-model="query.channelCode2" placeholder="资源名称" style="width:285px;"
                               filterable clearable>
                        <el-option value="" label="所有资源" />
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">系统产品</label> 
                     <el-select v-model="query.goodsId2" multiple collapse-tags placeholder="产品名称，可多选" filterable
                                clearable style="width:285px;" class=" mr10">
                        <el-option value="" label="所有产品" />
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal"
                                   :value="item.optVal" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">下游渠道</label> 
                    <el-select v-model="query.mids2" placeholder="下游渠道" filterable clearable class="mr10"
                               style="width:285px">
                        <el-option value="" label="所有渠道" />
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select> 
                </span>
                <span class="label-span">
                    <label class="label">剔除扣量</label> 
                    <el-select v-model="query.isDeduction" placeholder="剔除扣量" filterable class="mr10"
                               style="width:120px">
                        <el-option value="0" label="不剔除" />
                        <el-option value="1" label="已剔除" />
                    </el-select>
                </span>

                <el-button type="success" icon="el-icon-search" class="mr10" @click="handleSearchDataBody4()">查询</el-button>
            </el-card>

            <el-card shadow="hover"
                     v-loading="loading1"
                     style="margin-top:5px;height:300px;">
                <div class="wid2" style="height:300px;">

                    <p class='chartTitle green'>总进单量：{{avg.total}}</p>
                    <div class='table1' style="padding:15px 0 30px;">
                        <el-table :data="avg.tableData" border row-key="superiorId" :highlight-current-row="true">
                            <el-table-column label="通过步骤" align="center" prop="crossName"></el-table-column>
                            <el-table-column label="通过单量" align="center" prop="crossNum"></el-table-column>
                            <el-table-column label="通过比例" align="center" prop="crossPre">
                                <template slot-scope="scope">
                                    {{ scope.row.crossPre }} %
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>
                <div class="wid2" style="height:320px;">

                    <p class='chartTitle green'>订单状态饼形图</p>
                    <div ref="chart2" style="width: 400px; height: 220px;margin:0 auto" ></div>

                </div>
                <div class="wid2" style="height:320px;">

                    <p class='chartTitle green'>通过率漏斗</p>
                    <div ref="chart1" style="width: 400px; height: 220px;margin:0 auto"></div>

                </div>
            </el-card>
            <div style="padding-bottom:30px">
                <el-card class="box-card100">
                    <div slot="header" class="clearfix">
                        <span><span class="boomDanger">●</span>系统拦截原因汇总 </span>
                        <el-tag  v-if="tableData8.total>0"  class="tagBlack">系统拦截量：{{tableData8.total}}</el-tag>
                        <el-tag  v-if="tableData8.total>0"  class="tagBlack">系统拦截率：{{(tableData8.total / avg.total * 100).toFixed(2)}}%</el-tag>
                        <div  style="float: right">
                            <el-radio-group v-model="tableData8.limit">
                                <el-radio :label="5"  border>前5条</el-radio>
                                <el-radio :label="10" border>前10条</el-radio>
                                <el-radio :label="15" border>前15条</el-radio>
                                <el-radio :label="-1" border>加载全部</el-radio>
                            </el-radio-group>
                        </div>

<!--                        <el-button style="float: right; padding: 3px 0" type="text"-->
<!--                                   @click="tableData8.limit=-1"-->
<!--                        > {{ tableData8.limit === -1 ? '已加载全部' : '加载全部' }}</el-button>-->
                    </div>
                    <el-table :data="displayedTableData2List(tableData8)" style="margin-top:-20px;" row-key="superiorId"
                              v-loading="loading2"
                              :highlight-current-row="true"
                              max-height="400">
                        <el-table-column label="序号" width="60" align="center"  type="index">

                        </el-table-column>
                        <el-table-column label="失败原因" min-width="200" align="left" prop="message"></el-table-column>
                        <el-table-column label="失败数量" width="100" align="left" prop="total"></el-table-column>
                        <el-table-column label="失败占比" min-width="80" align="center" prop="avg">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                             color="#ff0000 "></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card100">
                    <div slot="header" class="clearfix">
                        <span><span class="boomDanger">●</span>校验失败原因汇总 </span>
                        <el-tag  v-if="tableData2.total>0"  class="tagBlack">校验失败量：{{tableData2.total}}</el-tag>
                        <el-tag  v-if="tableData2.total>0"  class="tagBlack">校验失败率：{{(tableData2.total / avg.total * 100).toFixed(2)}}%</el-tag>

                        <div  style="float: right">
                            <el-radio-group v-model="tableData2.limit">
                                <el-radio :label="5"  border>前5条</el-radio>
                                <el-radio :label="10" border>前10条</el-radio>
                                <el-radio :label="15" border>前15条</el-radio>
                                <el-radio :label="-1" border>加载全部</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <el-table :data="displayedTableData2List(tableData2)" style="margin-top:-20px;" row-key="superiorId"
                              v-loading="loading2"
                              :highlight-current-row="true"
                              max-height="400">
                        <el-table-column label="序号" width="60" align="center"  type="index">

                        </el-table-column>
                        <el-table-column label="失败原因" min-width="200" align="left" prop="message"></el-table-column>
                        <el-table-column label="失败数量" width="100" align="left" prop="total"></el-table-column>
                        <el-table-column label="失败占比" min-width="80" align="center" prop="avg">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                             color="#ff0000 "></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <el-card class="box-card100">
                    <div slot="header" class="clearfix">
                        <span><span class="boomDanger">●</span>短信失败原因汇总 </span>
                        <el-tag  v-if="tableData3.total>0"  class="tagBlack">短信失败量：{{tableData3.total}}</el-tag>
                        <el-tag  v-if="tableData3.total>0"  class="tagBlack">短信失败率：{{(tableData3.total / avg.total * 100).toFixed(2)}}%</el-tag>
                        <div  style="float: right">
                            <el-radio-group v-model="tableData3.limit">
                                <el-radio :label="5"  border>前5条</el-radio>
                                <el-radio :label="10" border>前10条</el-radio>
                                <el-radio :label="15" border>前15条</el-radio>
                                <el-radio :label="-1" border>加载全部</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <el-table :data="displayedTableData2List(tableData3)" style="margin-top:-20px;" row-key="superiorId"
                              v-loading="loading3"
                              :highlight-current-row="true"
                              max-height="400">
                        <el-table-column label="序号" width="60" align="center" type="index">

                        </el-table-column>
                        <el-table-column label="失败原因" min-width="200" align="left" prop="message"></el-table-column>
                        <el-table-column label="失败数量" width="100" align="left" prop="total"></el-table-column>
                        <el-table-column label="失败占比" min-width="80" align="center" prop="avg">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                             color="#ff0000 "></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <el-card class="box-card100">
                    <div slot="header" class="clearfix">
                        <span><span class="boomDanger">●</span>回填失败原因汇总 </span>
                        <el-tag v-if="tableData4.total>0"  class="tagBlack">回填失败量：{{tableData4.total}}</el-tag>
                        <el-tag v-if="tableData4.total>0"  class="tagBlack">回填失败率：{{(tableData4.total / avg.total * 100).toFixed(2)}}%</el-tag>
                        <div  style="float: right">
                            <el-radio-group v-model="tableData4.limit">
                                <el-radio :label="5"  border>前5条</el-radio>
                                <el-radio :label="10" border>前10条</el-radio>
                                <el-radio :label="15" border>前15条</el-radio>
                                <el-radio :label="-1" border>加载全部</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <el-table :data="displayedTableData2List(tableData4)" style="margin-top:-20px;" row-key="superiorId"
                              :highlight-current-row="true"
                              v-loading="loading4"
                              max-height="400">
                        <el-table-column label="序号" width="60" align="center" prop="failNum" type="index">

                        </el-table-column>
                        <el-table-column label="失败原因" min-width="200" align="left" prop="message"></el-table-column>
                        <el-table-column label="失败数量" width="100" align="left" prop="total"></el-table-column>
                        <el-table-column label="失败占比" min-width="80" align="center" prop="avg">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                             color="#ff0000 "></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <el-card class="box-card100">
                    <div slot="header" class="clearfix">
                        <span><span class="boomDanger">●</span>订购失败原因汇总 </span>
                        <el-tag v-if="tableData5.total>0" class="tagBlack">订购失败量：{{tableData5.total}}</el-tag>
                        <el-tag v-if="tableData5.total>0"  class="tagBlack">订购失败率：{{(tableData5.total / avg.total * 100).toFixed(2)}}%</el-tag>
                        <div  style="float: right">
                            <el-radio-group v-model="tableData5.limit">
                                <el-radio :label="5"  border>前5条</el-radio>
                                <el-radio :label="10" border>前10条</el-radio>
                                <el-radio :label="15" border>前15条</el-radio>
                                <el-radio :label="-1" border>加载全部</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <el-table :data="displayedTableData2List(tableData5)" style="margin-top:-20px;" row-key="superiorId"
                              :highlight-current-row="true"
                              v-loading="loading5"
                              max-height="400">
                        <el-table-column label="序号" width="60" align="center" type="index">

                        </el-table-column>
                        <el-table-column label="失败原因" min-width="200" align="left" prop="message"></el-table-column>
                        <el-table-column label="失败数量" width="100" align="left" prop="total"></el-table-column>
                        <el-table-column label="失败占比" min-width="80" align="center" prop="avg">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                             color="#ff0000 "></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <!-- 添加 5 个空白 div 撑开高度 -->
                <div style="height: 20px;" v-for="n in 5" :key="n"></div>
            </div>


        </div>

    </div>

</template>

<script>

import * as echarts from 'echarts';
import bus from '../../common/bus';
import { fetchData, getMessage } from '../../../api/dashBoard';
import { getPayInfo } from '../../../api/cashApply';
import { conversionAnalysis,failAnalysis } from '@/api/orderStatistics/orderStatustucs';
import { fetchSelect } from '@/api/comGoods';
import { fetchSelect as fetchSelect3 } from '@/api/member';
import { fetchSelect as fetchSelect6 } from '@/view/channel/channel';
export default {
    // props: ['selectData', 'select3Data','select6Data'],
    name: 'dashboard',
    data() {
        return {
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
            pickerOptions2: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            i: '1',
            myChart:{},
            chart2Dom:{},

            query: {
                dataType2: '1',
                startDay: '',
                endDay: '' ,
                isDeduction: '0',
                goodsId2: [],
                mids2: [],
                channelCode2: [],
            },
            avg:{
                total:1000,
                tableData: [
                    { crossName: '校验通过', crossNum: '880', crossPre: '88.00' },
                    { crossName: '短信通过', crossNum: '380', crossPre: '38.00' },
                    { crossName: '回填通过', crossNum: '80', crossPre: '18.00' },
                    { crossName: '订购成功', crossNum: '80', crossPre: '8.00' }
                ]

            },
            select: { option: '' },
            select3: { option: '' },
            select6: { option: '' }, 
            tableData2: {
                limit: 5,
                list: [

                ],
                total: 0
            },
            tableData8: {
                limit: 5,
                list: [

                ],
                total: 0
            },
            tableData3: {
                limit: 5,
                list: [

                ],
                total: 0
            },
            tableData4: {
                limit: 5,
                list: [

                ],
                total: 0
            },
            tableData5: {
                limit: 5,
                list: [

                ],
                total: 0
            },
            picData : {

                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}%'
                },
                toolbox: {
                    feature: {
                        //dataView: {readOnly: false},
                        //restore: {},
                        saveAsImage: {}
                    }
                },
                /*legend: {
                    data: [  '校验通过 880','短信通过 380','回填通过 180','订购成功 80']
                }, */
                series: [
                    {
                        name: '转化率',
                        type: 'funnel',
                        left: '5%',
                        top: 5,
                        bottom: 20,
                        width: '70%',
                        height: '220',
                        // height: {totalHeight} - y - y2,
                        //min: 0,
                        //max: 100,
                        // minSize: '0%',
                        // maxSize: '100%',
                        minSize: '0%',              //每一块的最小宽度
                        maxSize: '80%',               //每一块的最大快递   一次去除掉尖角
                        sort: 'descending', //排序 ascending descending
                        gap: 5,                //每一块之间的间隔
                        // label: {            //设置每一块的名字是显示在图里面还是外面
                        //     show: true,
                        //     position: 'inside'
                        // },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: [
                            { value: 88.00, name: '校验通过 88.00%' },
                            { value: 38.00, name: '短信通过 38.00%' },
                            { value: 18.00, name: '回填通过 18.00%' },
                            { value: 8.00, name: '订购成功 8.00%' }
                        ]
                    }
                ]
            },
            option : {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: ["校验失败",
                        "校验成功",
                        "短信失败",
                        "短信成功",
                        "回填失败",
                        "订购成功"]
                },
                series: [
                    {
                        name: '状态',
                        type: 'pie',
                        radius: '55%',
                        center: ['40%', '50%'],
                        data: [
                            {
                                "name": "校验失败",
                                "value": 10
                            },
                            {
                                "name": "校验成功",
                                "value": 1
                            },
                            {
                                "name": "短信失败",
                                "value": 1
                            },
                            {
                                "name": "短信成功",
                                "value": 1
                            },
                            {
                                "name": "回填失败",
                                "value": 1
                            },
                            {
                                "name": "订购成功",
                                "value": 1
                            }],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }

        };
    },
    components: {},
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('data-body4');
    },
    mounted() { 
        this.initData();
        this.initChart();

        bus.$on('data-body4',  row  => {
            this.initData();
            this.initChart(); 
        });
        
    },
    created(){
        this.getSelect();
        this.getSelect3();
        this.getSelect6();
        
    },
    computed: {


    },
    methods: {
        displayedTableData2List(tableData) {
            if (tableData.limit === -1) {
                // 显示全部数据
                return tableData.list;
            } else {
                // 只显示前 N 条数据
                return tableData.list.slice(0, tableData.limit);
            }
        },
        getSelect() {
            this.select = {};
            fetchSelect(this.select).then(res => {
                if (res.code == '200') { 
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect3() {
            this.select3 = {};
            fetchSelect3(this.select3).then(res => {
                if (res.code == '200') {
                    this.$set(this.select3, 'option', res.data);
                }
            });
        },
        getSelect6() {
            this.select6 = {};
            fetchSelect6(this.select6).then(res => {
                if (res.code == '200') {
                    this.$set(this.select6, 'option', res.data);
                }
            });
        },
        initData(){ 
            const nowDate = new Date();
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth(),
                day: nowDate.getDate(),
                hour: nowDate.getHours(),
                minute: nowDate.getMinutes(),
                second: nowDate.getSeconds()
            };
            if (date.month == 0) {
                date.month = 12;
                date.year = date.year - 1;
            } else {
                date.month = date.month + 1;
            }
            const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 00:00:00';
            const dayDate2 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 23:59:59';
                // + " "+(date.hour >= 10 ? date.hour : '0' + date.hour)+':'+(date.minute >= 10 ? date.minute : '0' + date.minute)+':'+(date.second >= 10 ? date.second : '0' + date.second);
            this.$set(this.query, 'startDay', dayDate1.toString());
            this.$set(this.query, 'endDay', dayDate2.toString());
            this.handleSearchDataBody4() 
        },
        initFail(){
            this.handleSearchByStatus(-1,this.tableData5);
            this.handleSearchByStatus(4,this.tableData4);
            this.handleSearchByStatus(2,this.tableData3);
            this.handleSearchByStatus(0,this.tableData2);
            this.handleSearchByStatus(8,this.tableData8);
        },

        handleSearchByStatus(status, tableData) {
            if (status === 0) this.loading2 = true;
            if (status === 2) this.loading3 = true;
            if (status === 4) this.loading4 = true;
            if (status === -1) this.loading5 = true;

            let query2 = this.getQuery2();
            query2.status = status;
            failAnalysis(query2).then(res => {
                console.log('failAnalyysis数据返回=============>>>' + res);
                if (res.code == 200) {
                    const result = res.data || {};
                    // 使用 $set 确保响应式更新
                    this.$set(tableData, 'list', result.list || []);
                    this.$set(tableData, 'total', result.total || 0);
                    if (!result.list ){
                        // this.$message.info('暂无数据');
                        console.log('暂无数据');
                    }

                }
                // 关闭对应的 loading
                if (status === 0) this.loading2 = false;
                if (status === 2) this.loading3 = false;
                if (status === 4) this.loading4 = false;
                if (status === -1) this.loading5 = false;
            });
        },
        handleArray(arr) {
            let arrCopy = '';
            if (arr != undefined && arr.length > 0) {
                arrCopy = arr.join();
                if (arrCopy.charAt(0) === ',') {
                    arrCopy = arrCopy.substring(1);
                }
                return arrCopy;
            }
            return null;
        },
        handleSearchDataBody4() {
            this.loading1 = true;
            let query2 = this.getQuery2();
            conversionAnalysis(query2).then(res => {
                console.log('dataStatistics数据返回=============>>>' + res);
                if (res.code == 200) {
                    const result = res.data || {};
                    console.log('this.result===>>>' , result);
                    this.avg = result;
                    // this.picData.series[0].data = result.avgData;
                    this.$set(this.picData.series[0], 'data', result.avgData);
                    this.myChart.setOption(this.picData);
                    if (result.stringStatusList && result.stringStatusList.length > 0){
                        console.log('stringStatusList===>>>' , result.stringStatusList);
                        let stringStatusList = result.stringStatusList;
                        //stringStatusList 中每个元素都有字符串的stauts属性和total属性,请提取所有的status
                        let statusList = stringStatusList.map(item => item.name);
                        this.$set(this.option.legend, 'data',statusList);
                        this.$set(this.option.series[0], 'data',result.stringStatusList);
                        console.log('this.option===>>>' ,this.option)
                        // 使用 echarts 实例的 setOption 方法，并添加 { notMerge: true } 参数
                        this.$nextTick(() => {
                            if (this.chart2Dom) {
                                this.chart2Dom.setOption(this.option, { notMerge: true });
                            }
                        });
                    }

                }
                this.loading1 = false;
            });
            this.initFail();
        },
        getQuery2(){
            console.log('this.query===>>>' + this.query.startDay);
            console.log(this.query);

            this.query.goodsId = this.handleArray(this.query.goodsId2);
            this.query.mids =  this.query.mids2;
            this.query.channelCode =  this.query.channelCode2;

            let query2 = JSON.parse(JSON.stringify(this.query));
            query2.goodsId2 = null;
            query2.mids2 = null;
            query2.channelCode2 = null;
            return query2;
        },
        initChart() {
            // 获取DOM元素
            const chartDom = this.$refs.chart1;
            const chart2 = this.$refs.chart2;

            // 初始化ECharts实例
            this.myChart = echarts.init(chartDom);
            this.chart2Dom = echarts.init(chart2);

            // 配置图表选项


            // 使用配置项显示图表
            this.myChart.setOption(this.picData);
            this.chart2Dom.setOption(this.option);
        }
    }
};
</script>


<style>
.panSelectMore {
    width: 99%;
    margin: 5px 0 20px 1%;
    text-align: left;
}

.table1, .table2 {
    margin: 0 1%;
    width: 98%;
}

.table2 {
    margin-top: 35px;
}

.table1 .cell {
    color: #777;
    font-weight: 900;
}

.el-table__row .cell {
    font-weight: 500;
}

.chartTitle {
    text-align: center;
    margin: 0px 0 15px;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.box-card100 {
    width: 100%;
    margin-top: 5px;
}

.reasonList ul li {
    list-style: none;
    float: left;
}

.reasonList ul li:nth-child(1) {
    width: 80%;
}

.reasonList ul li:nth-child(2) {
    width: 20%;
}

.el-progress-bar__innerText {
    color: #fff !important;
    margin-left: 20px;

}

.el-progress-bar__outer {
    background-color: rgb(210, 210, 210) !important;
}

.wid2 {
    float: left;
    text-align: center;
}

.wid2:nth-child(1) {
    width: 32%;
    margin-right:3%;
}

.wid2:nth-child(2) {
    width: 32%;
    margin-right:3%;
}
.wid2:nth-child(3) {
    width: 28%;
}

@media screen and (max-width: 999px) {
    .wid2 {
        width: 100%;
        float: left;
        text-align: center;
    }
}


</style>
 
